let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kLFgm")).then(() => parcelRequire('dOK5O'));